module.exports = __webpack_public_path__ + "img/minigame.84d8860b.jpg";